import React from 'react';
import { StyledTag, TagText, StyledTagDeleteButton, SelectedTag, StyledIcon } from './styled.js';

const Tag = (props) => {
  const { data = {}, onClick, type, selected, deleteEnabled, icon, children } = props;
  const { value } = data;
  const textValue = typeof data === 'string' ? data : value;
  /*
   * Check if explicitly defined && specifically not false. deleteEnabled can
   * be undefined, but if it's explicitly false, we want to restrict clicking
   * Example of cases:
   *  - Keyword is clickable as a link, but not deleteEnabled (unless rendered as a filter)
   *  - Content filter has an onClick and typically deleteEnabled,
   *    but deleteEnabled could be explicitly false under certain views (like Insights)
   */
  const clickable = onClick !== undefined && deleteEnabled !== false;

  if (selected) {
    return (
      <SelectedTag
        clickable={clickable}
        onClick={() => clickable && onClick && onClick(data)}
        type={type}
        icon={icon}
        deleteEnabled={deleteEnabled}
      >
        {icon ? <StyledIcon url={icon} /> : null}
        <TagText>
          {textValue}
        </TagText>
        {deleteEnabled ? <StyledTagDeleteButton>×</StyledTagDeleteButton> : null}
      </SelectedTag>
    );
  }

  return (
    <StyledTag
      clickable={clickable}
      onClick={() => onClick && onClick(data)}
      type={type}
      icon={icon}
    >
      {icon ? <StyledIcon url={icon} /> : null}
      <TagText>
        {textValue}
      </TagText>
      {deleteEnabled ? <StyledTagDeleteButton>×</StyledTagDeleteButton> : null}
      {children}
    </StyledTag>
  );
};

export default Tag;
